module.exports = __webpack_public_path__ + "static/Chapter-Regular-408dbcaa85b72b8b04825115feae0b36.woff";